import React from 'react';
import WhyUs from '@/components/WhyUs';
import Team from '@/components/Team';
import ScrollReveal from '@/components/ScrollReveal';
import FullAccreditation from '@/components/FullAccreditation';

const About = () => {
  return (
    <div className="pt-24 pb-16">
      <ScrollReveal>
        <WhyUs />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <Team />
      </ScrollReveal>
      <ScrollReveal delay={0.2}>
        <FullAccreditation />
      </ScrollReveal>
    </div>
  );
};

export default About;
